import { useTranslation } from 'react-i18next';

import type { Doc } from '~/types/user';

import { useDownloadDocument } from '~/api/user';
import { Button } from '~/components';
import { toast } from '~/utils/toast';

export const DocumentDownloadCell = ({ document }: { document: Doc }) => {
  const mutation = useDownloadDocument();

  const { t } = useTranslation(['common']);

  return (
    <Button
      aria-label={t('common:datatable.download')}
      icon="Download"
      loading={mutation.isPending}
      onClick={() => mutation.mutate(document.id, { onError: () => toast.danger({ description: t('common:error') }) })}
    />
  );
};
